import { createContext } from 'react'

const UserContext = createContext()

export { UserContext }